<div class="ibox-content">
    <form [formGroup]="form">
      <div class="form-group row">
        <mat-error *ngIf="MensajeError" class="eliminacionInvalida">{{MensajeError}}</mat-error>
        <mat-error *ngIf="MensajeRetro && !MensajeError && formHabilitado" class="eliminacionInvalida">{{MensajeRetro}}</mat-error>
      </div>
      <div class="row" hidden="true">
        <input formControlName="id" name="id" type="text" class="form-control" />
        <input formControlName="personal" name="personal" type="text" class="form-control" />
      </div>
      <div class="row panel panel-warning" *ngIf="!disabledEditing">
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error *ngIf="desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
            </mat-error>
            <mat-error *ngIf="anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al límite de retroactividad {{grupoLiq.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
            </mat-error>
          </div>
        </div>
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
                La Fecha no puede ser menor que la Fecha Desde
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-form-label font-bold">Clase</label>
            <div>
              <comboTools [list]=clasesAfiliacionList
                        selected='claseAfiliaciones'
                        [formParent]="form"
                        [isEditing]=disabledEditing
                        filter="descripcion"></comboTools>
              <div *ngIf="registerFormControl.claseAfiliaciones.invalid && (registerFormControl.claseAfiliaciones?.dirty || registerFormControl.claseAfiliaciones?.touched || submitted)" class="text-danger">
                Clase es Requerido
              </div>
            </div>
          </div>
        </div> 
        <div class="col-md-6">
          <div class="form-group">
            <label class=" col-form-label font-bold">Descripción</label>
            <input formControlName="descripcion" maxlength="50" name ="selectedDescripcion" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.descripcion.errors && (registerFormControl.descripcion?.dirty || registerFormControl.descripcion?.touched || submitted)}"/>
            <mat-error  class="text-danger"*ngIf="registerFormControl.descripcion.errors?.required && (registerFormControl.descripcion?.dirty || registerFormControl.descripcion?.touched || submitted)">
                La Descripción es Requerida
            </mat-error>
          </div>
        </div> 
      </div>
    </form>
  </div>
  
  